import 'BrokerTsLib/src/extensions/date.extensions'

import type {
  GridProps
} from '@chakra-ui/react'
import {
  Button,
  forwardRef,
  Link
} from '@chakra-ui/react'
import type { InsuranceParamsVehiclePagedQuery } from 'BrokerTsLib/src/dtos'
import { useEffect, useMemo, useState } from 'react'
import { Link as rrdLink } from 'react-router'

import { usePartner } from '@/context/PartnerContext'
import { useApp } from '@/hooks/useApp'

import { useTranslationsContext } from 'BrokerTsLib/src/context/TranslationsContext'
import { useAuth } from '../../context/AuthContext'
import { useGetAll } from '../../hooks/useInsuranceParams'
import { ContractsList, getContractsContext } from '../contracts/ContractsList'
import { DashboardCard } from './DashboardCard'


export type AnniversaryCardProps = GridProps

export const AnniversaryCard = forwardRef(
  ({ children, ...rest }: AnniversaryCardProps, ref) => {
    const { user } = useAuth()!
    const { currentPartner } = usePartner()
    const { product, currentApp } = useApp()
    const { translate } = useTranslationsContext()

    let anniversaryLimitLow = 0
    let anniversaryLimitHigh = 60
    if (currentPartner && currentPartner.partner == 'Kapitol') {
      anniversaryLimitLow = 28 // Pro Kapitol zobrazujeme od 4 do 10 týdnů
      anniversaryLimitHigh = 70
    }

    const [currentPage, setCurrentPage] = useState(1)
    const [pageSize, setPageSize] = useState(5)
    const [filter, setFilter] = useState<InsuranceParamsVehiclePagedQuery>({
      anniversaryFrom: new Date().customAddDays(anniversaryLimitLow),
      anniversaryTo: new Date().customAddDays(anniversaryLimitHigh),
      listType: 2,
      pageIndex: 1,
    })

    const { data, mutateAsync, isPending } = useGetAll()
    const concepts = data?.data
    const items = concepts?.items ?? []

    useEffect(() => {
      setFilter({ ...filter, pageSize: pageSize, pageIndex: currentPage })
    }, [pageSize, currentPage])

    useEffect(() => {
      if (!user?.id) return

      if (filter.pageSize) // nechci spoustet nacitani na pageload 2x
        mutateAsync(filter)
    }, [filter, product])

    const ctx = useMemo(() => getContractsContext(product!), [product])

    return (
      <DashboardCard
        ref={ref}
        title={translate('ui.Dashboard.Aniversary.Title', 'Blížící se výročí smluv')}
        // badge={`${items.length} / ${concepts?.totalCount}`}
        {...rest}
      >
        {children}

        <ctx.Provider value={
          {
            loading: isPending,
            totalCount: concepts?.totalCount ?? 0,
            currentPage,
            pageSize,
            filter,
            setCurrentPage,
            setPageSize,
            updateFilter: setFilter,
            reload: () => mutateAsync(filter)
          }
        }>
          <ContractsList
            contracts={items}
            loading={isPending}
            withPaginator
            leftFooterPart={(
              <Link as={rrdLink} to={`${currentApp?.path?.replace(/\/$/, '')}/contracts`} sx={{ display: 'flex' }}>
                <Button type="button" variant="link" mr={'auto'}>
                  {translate('more', 'Více')}
                </Button>
              </Link>
            )}
          />
        </ctx.Provider>
      </DashboardCard>
    )
  },
)
